import ForgeryProtection from "lib/ForgeryProtection"

export type FieldErrors = Record<string, string>

type ServerErrors = Record<string, string[] | string>

export interface AuthorCommunication {
  authorId: number | string
  reason: string
  message: string
}

// errors only when the server rejected fields.
export interface SubmitResult {
  ok: boolean
  errors?: FieldErrors
}

const toFieldErrors = (errors: ServerErrors): FieldErrors =>
  Object.entries(errors).reduce<FieldErrors>((result, [field, messages]) => {
    result[field] = Array.isArray(messages) ? messages.join(", ") : String(messages)
    return result
  }, {})

export default async function submitAuthorCommunication({
  authorId,
  reason,
  message,
}: AuthorCommunication): Promise<SubmitResult> {
  try {
    const { token } = await ForgeryProtection.CSRF
    const response = await fetch("/author_communications", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        // Signed out, an XHR gets a 404 rather than a redirect to sign in.
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ author_communication: { to_author_id: authorId, reason, message } }),
    })

    // A followed redirect ends on another page; its 2xx isn't a send.
    if (response.ok && !response.redirected) return { ok: true }

    const data: { errors?: ServerErrors } | null = await response.json().catch((): null => null)
    return data?.errors ? { ok: false, errors: toFieldErrors(data.errors) } : { ok: false }
  } catch {
    return { ok: false }
  }
}
